// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import RankTier from "./rank_tier_type";


export default __t.object("RankedPlaza", {
  userId: __t.u64(),
  get tier() {
    return RankTier;
  },
  eloAtAssignment: __t.i32(),
  assignedAt: __t.u64(),
  plazaRank: __t.u32(),
  username: __t.option(__t.string()),
  rpAtAssignment: __t.i32(),
});


